import { render, staticRenderFns } from "./CDOrganizationsNav.vue?vue&type=template&id=5eb764d7&scoped=true"
import script from "./CDOrganizationsNav.vue?vue&type=script&lang=ts"
export * from "./CDOrganizationsNav.vue?vue&type=script&lang=ts"
import style0 from "./CDOrganizationsNav.vue?vue&type=style&index=0&id=5eb764d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb764d7",
  null
  
)

export default component.exports